import { HStack } from '@chakra-ui/react';
import SidebarButton from './SidebarButton';
import NewChatButton from './NewChatButton';

const SidebarHeader = ({
  onClose,
  setActiveConversationId,
  setMessages,
  isDisabled,
  setSearchResults,
}) => {
  return (
    <HStack
      justifyContent='space-between'
      p={2.5}
      borderBottom='1px solid gray.300'
    >
      <NewChatButton
        setActiveConversationId={setActiveConversationId}
        setMessages={setMessages}
        isDisabled={isDisabled}
        setSearchResults={setSearchResults}
      />
      <SidebarButton onClose={onClose} />
    </HStack>
  );
};

export default SidebarHeader;
